import { render, staticRenderFns } from "./NavHub.vue?vue&type=template&id=88785b00"
import script from "./NavHub.vue?vue&type=script&lang=js"
export * from "./NavHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports